import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import './Resources.scss';

import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus } from '../actions';

import Accordion from '../components/Accordion';
import { knowledgeBaseArray } from '../utilities/KnowledgebaseContent';
import orientationVideo from '../assets/orientation_video.webm';
import adaptiveEnergyVideo from '../assets/adaptive_energy_management.webm';
import hvacClimateControls from '../assets/hvac_climate_controls.webm';
import icon_email from '../assets/icon_email.svg';
import icon_phone from '../assets/icon_phone.svg';
import apple_share from '../assets/icon_apple_share.svg';
import ResourcesIcon from '../components/icons/ResourcesIcon';

const Resources = ({ showMobile }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <section className={`pages--resources resources-section ${showMobile ? 'mobile' : 'desktop'}`}>
      <div className={showMobile ? 'header-container mobile' : 'header-container'}>
        <div className="header">
          <ResourcesIcon
            backgroundFill={'none'}
            outerStrokeColor={'#02222B'}
            innerStrokeColor={'#02222B'}
            strokeWidth={2.5}
            width="18px"
          />
          <h1>Resources & Support</h1>
        </div>
      </div>

      <div className="top-container">
        <div className="container support-container">
          <h2>Support</h2>

          <div className="support-details">
            <p>Hours: 9am - 5pm (PST)</p>
            <p>
              Callback within:
              <br />
              1 hour (Weekdays)
              <br />4 hours (Weekends)
            </p>
          </div>

          <div className="contact">
            <a href="mailto:support@elexity.io" className="email-us">
              <img src={icon_email} alt="email icon" width="14" height="14" />
              support@elexity.io
            </a>

            <a href="tel:5102259329" className="call-us">
              <img src={icon_phone} alt="phone icon" width="14" height="14" />
              510-225-9329
            </a>
          </div>
        </div>

        <div className="container download-container">
          <div>
            <h2>Add the Elexity App to your iPhone</h2>

            <ol>
              <li>Open Safari or Chrome: Launch the browser app on your iPhone.</li>
              <li>
                Navigate to the website:{' '}
                <a href="https://ahi.elexity.net" target="_blank">
                  https://ahi.elexity.net
                </a>
              </li>
              <li>
                Tap the Share button<img src={apple_share} height={25} width={25}></img>
              </li>
              <ul>
                <li>In Safari: located at the bottom of the screen.</li>
                <li>In Chrome: located in the address bar.</li>
              </ul>
              <li>
                Select "Add to Home Screen" -&gt; Tap the "Add to Home Screen" option from the share
                menu.
              </li>
              <li>
                Add to Home Screen -&gt; Tap "Add" to create the app-like icon on your home screen.
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div className="container tutorial-container">
        <h2>
          Tutorial Videos{' '}
          <span className="note">
            Note: Our video tutorials are being updated to reflect our new look and feel.
          </span>
        </h2>

        <section className="resources-section">
          <div className="resource-video">
            <h4>90 Second Orientation</h4>
            <video src={orientationVideo} width="320" height="240" controls />
          </div>

          <div className="resource-video">
            <h4>Adaptive Energy Management</h4>
            <video src={adaptiveEnergyVideo} width="320" height="240" controls />
          </div>

          <div className="resource-video">
            <h4>HVAC Climate Controls</h4>
            <video src={hvacClimateControls} width="320" height="240" controls />
          </div>
        </section>
      </div>

      <div className="container knowledgebase-container">
        <h2>Knowledge Base</h2>

        <section id="charts-data" className="kb-section">
          <div className="charts-data">
            {knowledgeBaseArray.map((item, index) => (
              <Accordion
                key={index}
                title={item.title}
                content={item.content}
                isActive={index === activeIndex}
                onToggle={() => handleToggle(index)}
              />
            ))}
          </div>
        </section>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentBuildingId: state.currentBuildingId,
    currentZoneId: state.currentZoneId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    currentUserData: state.currentUserData,
    campuses: state.campuses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Resources));
